import { debounce, throttle } from './utils';

function menuToggleHandler() {
  const menuStatus = document.documentElement.dataset.menu;
  document.documentElement.dataset.menu =
    menuStatus === 'closed' ? 'opened' : 'closed';
}

function windowResizeHandler() {
  const menuStatus = document.documentElement.dataset.menu;
  if (window.innerWidth >= 1024 && menuStatus === 'opened') {
    document.documentElement.dataset.menu = 'closed';
  }
}

function initMenuEvent() {
  const menuToggleButton = document.querySelector('#toggleMenu');
  menuToggleButton.addEventListener('click', throttle(menuToggleHandler));
  window.addEventListener('resize', debounce(windowResizeHandler));
}

export { initMenuEvent };
